import { render, staticRenderFns } from "./Decorado.vue?vue&type=template&id=5af2404e&scoped=true&"
import script from "./Decorado.vue?vue&type=script&lang=js&"
export * from "./Decorado.vue?vue&type=script&lang=js&"
import style0 from "./Decorado.vue?vue&type=style&index=0&id=5af2404e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2404e",
  null
  
)

export default component.exports